const rootActionPath = 'core/HybridStoresOfferModal';

export const HYBRID_STORES_OFFER_MODAL_VIEW = `${rootActionPath}/VIEW`;
